interface ExplanationCardProps {
  text: string;
  accentColor: string;
}

export function ExplanationCard({ text, accentColor }: ExplanationCardProps) {
  return (
    <div style={{
      background: "#fff",
      border: "1px solid #e8e8e8",
      borderLeft: `4px solid ${accentColor}`,
      borderRadius: 8,
      padding: "14px 16px",
    }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: "#888", marginBottom: 8, letterSpacing: 1 }}>
        解説
      </div>
      <p style={{ fontSize: 14, lineHeight: 1.8, color: "#555", margin: 0 }}>
        {text}
      </p>
    </div>
  );
}
